import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {UserAdminComponentTypeEnum} from "./user-admin-component-type.enum";
import {PageInfo} from "../../../shared/model/response/page-info.model";
import {PaginatorState} from "primeng/paginator";
import {AccountService} from "../../../service/api/account.service";
import {AdminUserFilterModel} from "../../../shared/model/request/admin-user-filter.model";
import {take} from "rxjs";
import {AccountResponse} from "../../../shared/model/response/account-response.model";

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    standalone: false
})
export class UsersComponent implements OnInit {

  protected readonly UserAdminComponentTypeEnum = UserAdminComponentTypeEnum;
  componentType: UserAdminComponentTypeEnum = null;

  users: AccountResponse[] = [];
  filters: AdminUserFilterModel = {}
  pagination: PageInfo

  constructor(
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService
  ) {
  }

  ngOnInit(): void {
    this.componentType = this.activatedRoute.snapshot.data['componentType']
    this.apiFetchUser(this.filters)
  }

  onFilterSubmit(filterData: AdminUserFilterModel) {
    this.filters = filterData
    this.apiFetchUser(this.filters)
  }

  onPageChange($event: PaginatorState) {
    this.apiFetchUser(this.filters, $event.page)
  }

  apiFetchUser(filters: AdminUserFilterModel, page?: number) {

    switch (this.componentType) {
      case UserAdminComponentTypeEnum.PRIVILEGE:
        filters.isPrivilege = true
        break
      case UserAdminComponentTypeEnum.BLOCKED:
        this.filters.isBlocked = true
        break
    }

    this.accountService.list(page, filters).pipe(take(1)).subscribe({

      next: (value) => {
        this.users = value?.data
        this.pagination = value.pageInfo
      },
      error: () => {
        if (page == 0) this.users = [];
      }
    })
  }

}
